import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import DemoClient from "./demo-client";
import "./globals.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root container is missing");

createRoot(container).render(
  <StrictMode>
    <DemoClient />
  </StrictMode>,
);
